import t from './state/types';

export default {
  cachePrefix: 'FF',
  cacheTime: 60 * 5, // seconds
  featuredPresets: ['distance-specialist', 'track-specialist'],
  requestDelay: 800, // milliseconds
  sortOptions: [
    {
      label: 'Next to Jump',
      value: t.SORT_TIME,
    },
    {
      label: 'Race meeting',
      value: t.SORT_NAME,
    },
  ],
};
